import { FuseUtils } from '@fuse';

export const GET_NAVIGATION = 'GET_NAVIGATION';
export const getNavigation = () => ({
	type: GET_NAVIGATION
});

export const SET_NAVIGATION = 'SET_NAVIGATION';
export const setNavigation = navigation => ({
	type: SET_NAVIGATION,
	navigation
});

export const RESET_NAVIGATION = 'RESET_NAVIGATION';
export const resetNavigation = () => ({
	type: RESET_NAVIGATION
});

export const appendNavigationItem = (item, parentId) => (dispatch, getState) => {
	const { navigation } = getState().fuse;
	return dispatch(setNavigation(FuseUtils.appendNavItem(navigation, item, parentId)));
};

export const prependNavigationItem = (item, parentId) => (dispatch, getState) => {
	const { navigation } = getState().fuse;
	return dispatch(setNavigation(FuseUtils.prependNavItem(navigation, item, parentId)));
};

export const updateNavigationItem = (id, item) => (dispatch, getState) => {
	const { navigation } = getState().fuse;
	return dispatch(setNavigation(FuseUtils.updateNavItem(navigation, id, item)));
};

export const removeNavigationItem = id => (dispatch, getState) => {
	const { navigation } = getState().fuse;
	return dispatch(setNavigation(FuseUtils.removeNavItem(navigation, id)));
};
